
import { useTranslation, Trans } from "react-i18next";

import i1 from '../../img/ProductsArvest/i1.png';
import i2 from '../../img/ProductsArvest/i2.png';

import i1mob from '../../img/ProductsArvest/i1mob.png';
import i2mob from '../../img/ProductsArvest/i2mob.png';

import Button from '../Button'

const WhatIsTrade = () => {

    const { t } = useTranslation();

    const lines = t('productsarvest.15').split('<br/>');

    return (
        <section className="relative open-sans pt-[90px] xl:pt-[160px]">
            <div className="relative z-10 max-w-[1220px] xl:mx-auto">
                <div className="flex xl:flex-row flex-col justify-between gap-[30px]">
                    <img src={i1} alt="" className="h-[168px] xl:h-auto object-cover hidden xl:block"/>
                    <img src={i1mob} className="xl:hidden block" alt="" />
                    <div className="flex justify-center flex-col mx-[20px] xl:mx-0">
                        <h2 className="max-w-[390px] sm:text-[19px] font-[700] text-[14px] text-[#0C2780]">
                            {t('productsarvest.11')}
                        </h2>
                        <p className="sm:text-[16px] font-[300] text-[14px] text-[#0C2780] sm:my-[15px] my-[13px]">
                            {t('productsarvest.12')}
                        </p>
                        <p className="sm:text-[16px] font-[300] text-[14px] text-[#0C2780]">
                            {t('productsarvest.13')}
                        </p>
                        <Button color={'#15318D'} text={'#FFFFFF'} className={'mt-[40px]'}/>             
                    </div>
                </div>
                <div className="flex xl:flex-row-reverse flex-col justify-between gap-[30px] pt-[90px] xl:pt-0">
                    <img src={i2} alt="" className="h-[168px] xl:h-auto object-cover hidden xl:block"/>
                    <img src={i2mob} className="xl:hidden block" alt="" />
                    <div className="flex justify-center flex-col mx-[20px] xl:mx-0">
                        <h2 className="max-w-[390px] sm:text-[19px] font-[700] text-[14px] text-[#0C2780]">
                            {t('productsarvest.14')}
                        </h2>
                        <p className="sm:text-[16px] font-[300] text-[14px] text-[#0C2780] sm:my-[15px] my-[13px]">
                            {lines.map((line, index) => (
                                <span key={index} className="block mb-[10px]">
                                    <Trans>{line}</Trans>
                                </span>
                            ))}
                        </p>
                        <Button color={'#15318D'} text={'#FFFFFF'} className={'mt-[40px]'}/>             
                    </div>
                </div>
            </div>
        </section>
    )
};

export default WhatIsTrade;
